import { render, staticRenderFns } from "./accordion-room-beds.vue?vue&type=template&id=024291c1"
import script from "./accordion-room-beds.js?vue&type=script&lang=js&external"
export * from "./accordion-room-beds.js?vue&type=script&lang=js&external"
import style0 from "./accordion-room-beds.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports